const applyScreenSizeData = (data: { points: number; sources: number }) => {
  data.sources += 1;

  const width =
    window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  const height =
    window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

  if (width > 10 && height > 10) return;

  data.points += 10;
};

const scrapeProbabilityCalculator = () => {
  if (process.env.SSR) return 0;

  const data = {
    points: 0,
    sources: 0,
  };

  applyScreenSizeData(data);

  if (data.sources === 0 || data.points === 0) return 0;

  return data.points / data.sources;
};

export { scrapeProbabilityCalculator };
